import { PriceLabelDet } from "./PriceLabelDet";

export class PriceLabel {
    priceLabelId: number;
    organizationId: string;
    catDetTypePriceId: number;
    catDetPrinterTypeId: number;
    label: string;
    active: boolean;
    createdDate: Date;
    lastDateUpdate: Date;
    detail: PriceLabelDet[];
    catDetBarcodeTypeId: number;
    percentDiscount: boolean;
}